import APIService from '../api';

export default class AnalyticsService extends APIService {
  host() {
    return this.servicesHost();
  }

  getDashboardTransactions(
    time: { from: string; to: string },
    interval?: string
  ) {
    let defaultParams = `sort=x&order=DESC&dimensions=type&`;
    if (interval) {
      defaultParams += `&interval=${interval}`;
    }
    let resource = `/analytics/registrations?${defaultParams}`;

    if (!resource.includes('from')) {
      resource += this.dynamicResource(time);
    }

    return this.get(resource);
  }

  getBusinessRegistrations(
    time: { from: string; to: string },
    campaignBusinessId?: string,
    interval: string = 'day'
  ) {
    const defaultParams = `sort=x&order=DESC&interval=${interval}&dimensions=type&campaignBusinessId=${campaignBusinessId}`;
    let resource = `/analytics/registrations?${defaultParams}`;

    if (!resource.includes('from')) {
      resource += this.dynamicResource(time);
    }

    return this.get(resource);
  }

  getCampaignStatistics(from: string, to: string, firstcoinCampaignId: string) {
    return this.get(
      `/analytics/firstcoin-campaign-activity/activity/statistics?interval=day&from=${from}&to=${to}&firstcoinCampaignId=${firstcoinCampaignId}`
    );
  }
}
